import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormGroup, Validators, FormBuilder, NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormCanDeactivate } from 'src/app/shared/form-can-deactivate/form-can-deactivate';
import { CookiesService } from 'src/app/shared/cookies.service';

@Component({
	selector: 'app-update-general',
	templateUrl: './update-general.component.html',
	styleUrls: ['./update-general.component.scss']
})
export class UpdateGeneralComponent extends FormCanDeactivate implements OnInit {
	@Input() data
	@ViewChild('form')
 	form: NgForm;
	generalId: any;

	submitted = false;
	baseUrl = environment.okountUrl;
	generalForm: FormGroup;
	groupList: any;

	alertType = '';
	message: string = ``;
	countryArr: any = [];
	stateArr: any = [];
	cityArr: any = [];
	remainingAmount = 0
    amountType = 'credit'
	showMessage: boolean = false;
	generalData: any;
	isTenantIndian: boolean = false;
	parentAccountType: string = ''
	isHQBranch: boolean = false;
	branches: any = []
	vatAlternetname: string = 'VAT'
	companies: any = []
	isHQCompany: boolean = false;
	isAadesh: boolean = false;

	@ViewChild('confirmModal',{static:true}) confirmModal : ElementRef
	@ViewChild('closeModal',{static:true}) closeModal : ElementRef
	@ViewChild('confirmDeleteModal',{static:true}) confirmDeleteModal : ElementRef
	@ViewChild('closeDeleteModal',{static:true}) closeDeleteModal : ElementRef
	@ViewChild('confirmUpdateModal',{static:true}) confirmUpdateModal : ElementRef
	@ViewChild('closeUpdateModal',{static:true}) closeUpdateModal : ElementRef
	@ViewChild('confirmOBModal',{static:true}) confirmOBModal : ElementRef;
    @ViewChild('closeOBModal',{static:true}) closeOBModal : ElementRef;

	constructor(
		public commonService: CommonServiceService,
		private route: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService,
		private cookieService : CookiesService,
	) {
		super()
		this.route.paramMap.subscribe(params => {
			this.generalId = params['params'].id
		});

		this.generalForm = this.fb.group({
			parent_id: ['', Validators.required],
			account_name: ['', Validators.required],
			   account_type : [''] ,
			//   gst_expiry_date : [''] ,
			state_id : [''],
			state_name : [''],
      		gst_number: [''],
			vat_number: [''],
			hsn_code : [''],
			balance: [''],
			balance_type: ['debit'],
			status: [''],
			hierarchy: [''],
			currency_rate:[''],
			local_balance: [''],
			currency:[''],
			branch:{},
			company:{}
		})
	}

	async ngOnInit() {
		if(this.data) {
			this.generalId = this.data.general_id
		}
		if (this.generalId != undefined) {
			this.getGeneral()
		}
		this.getStates('101')
		this.isHQCompany = this.commonService.checkHQCompany()
		if(this.isHQCompany==true){
			this.getAllCompanys()
		}
		this.isHQBranch =await this.commonService.checkHQBranch()

		if(this.isHQBranch==true){
			this.getAllBranches()
			
			// this.branchForm = this.fb.group({
			// 	formObj
			// })
		}
		
		this.isTenantIndian = this.commonService.checkTenantIndian()
		if(!this.isTenantIndian){
			let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
			let inv_config = globalSettingConfig.filter(el=>el.group=='VAT')
		if(inv_config.length){
			let vat_config = inv_config[0].json_doc.value.filter(el=>el.key=='vat_rate')
			let vat_detail,vat_name
			if(vat_config.length){
				 vat_detail = vat_config[0].value
			}
			if(vat_detail && vat_detail.length ){
				vat_name = vat_detail.filter(el=>el.key=='effective_name')
			}
			if(vat_name && vat_name.length){
				this.vatAlternetname = vat_name[0].value
			}
		}
		}

	}
	getStates(country_id) {
		this.commonService.getOkount(`location/states?country_id=${country_id}`).subscribe(res => {
			this.stateArr = res
		})
	}

  	selectState(state_id) {
		let selectedState = this.stateArr.filter(option => {
			return option.location_id == Number(state_id);
		})
		if (selectedState.length > 0) {
			this.generalForm.controls.state_name.setValue(selectedState[0].name)
		}
	}

	getGeneral() {
		this.commonService.getOkount(`general?general_id=${this.generalId}`).subscribe(async (res) => {
			if (res[0] != undefined) {
				this.generalData = res[0]
			}
			console.log(this.generalData)
			await this.getGroups()
			await this.setGeneralData()

			
			
		})
	}
	setGeneralData() {
		if (this.generalForm != undefined && this.generalData != undefined) {
			this.generalForm.controls.parent_id.setValue(this.generalData.parent_id)
			this.generalForm.controls.account_name.setValue(this.generalData.account_name)
			this.generalForm.controls.balance.setValue(this.generalData.balance)
			this.generalForm.controls.status.setValue(this.generalData.status)
			this.generalForm.controls.hsn_code.setValue(this.generalData.hsn_code)
			this.generalForm.controls.state_id.setValue(this.generalData.state_id)
			this.generalForm.controls.state_name.setValue(this.generalData.state_name)
			this.generalForm.controls.gst_number.setValue(this.generalData.gst_number)
			this.generalForm.controls.vat_number.setValue(this.generalData.vat_number)
			this.generalForm.controls.balance_type.setValue(this.generalData.balance_type)
			this.generalForm.controls.hierarchy.setValue(this.generalData.hierarchy)
			this.generalForm.controls.account_type.setValue(this.generalData.account_type)
			this.generalForm.controls.currency.setValue(this.generalData.currency)
			this.generalForm.controls.currency_rate.setValue(this.generalData.currency_rate)
			this.generalForm.controls.local_balance.setValue(this.generalData.local_balance)
		}
	}

	openUpdateConfirmModal(){
		this.confirmUpdateModal.nativeElement.click()
		this.commonService.selectedInput.next(10)
	}

	closeUpdateConfirmModal(){
		this.closeUpdateModal.nativeElement.click()
	}


	updateGeneral() {
		debugger
		this.submitted = true;
		this.closeUpdateConfirmModal()
		if((this.generalForm.controls.account_type.value=="INCOME"|| this.parentAccountType=='INCOME') && !this.generalForm.controls.hsn_code.value){
			this.showMessage =true
				this.alertType = 'warning-box';
					this.message = 'FOR ACCOUNT TYPE "INCOME", HSN CODE IS MANDATORY'
				return false;
		}
		if (this.generalForm.valid) {
			this.commonService.putRequest(`${this.baseUrl}/general?general_id=${this.generalId}`, this.generalForm.value).subscribe(res => {
				this.updateOpeningBalanceAdjustAcc()
				this.showMessage = true
				this.alertType = 'success-box';
				this.message = 'General updated successfully.'
			}, error => {
				this.showMessage = true
				this.alertType = 'error-box';
				this.message = 'Failed to update General. Please try Again.'
			})
		}
		else {
			this.showMessage = true
			this.alertType = 'warning-box';
			this.message = 'Please fill mandatory fields.'
			return false;
		}
	}

	getGroups() {
		this.commonService.getOkount('v3account/getallsuperparents').subscribe(res => {
			this.groupList = res
			console.log('Group list : ', this.groupList)
			let parentAccount= this.groupList.filter(el=>el.account_code==this.generalData.parent_code)
			this.parentAccountType = parentAccount[0].account_type
			let generalParentId = parentAccount[0].id
			console.log("this.parentAccounttype",this.parentAccountType)
			console.log("generalParentId ",generalParentId )
			console.log("this.generalData.parent_id: ",this.generalData.parent_id)
			if(!this.generalData.parent_id && generalParentId) {
				this.generalForm.controls.parent_id.setValue(generalParentId)
			}
		}, err => {

		})
	}
	hideError() {
		this.showMessage = false
	}

	closeWindow() {
		window.close();
	}

	openDeleteConfirmModal(){
		this.confirmDeleteModal.nativeElement.click()
		this.commonService.selectedInput.next(12)
	}

	closeDeleteConfirmModal(){
		this.closeDeleteModal.nativeElement.click()
	}


	deleteGeneral(){
		// this.submitted = true;
		let generaLid = this.generalData.account_code
		this.closeDeleteConfirmModal()
		if(generaLid != ''){
			this.commonService.deleteRequest(`${this.baseUrl}/general?account_code=${generaLid}`).subscribe((res: any) => {
				this.generalForm.reset()
				this.showMessage = true
				this.alertType = 'success-box';
				this.message = `General Deleted.`
				this.spinner.hide();
			},
				err => {
					this.showMessage = true
					this.alertType = 'error-box';
					this.message = `Failed to delete general.`
					this.spinner.hide();
				})
		} else {
			this.generalForm.reset()
		}
	}


	openConfiguration(general_id) {
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/master/policy/default-general-policy/${general_id}`
		window.open(path,'_blank')
	}
	openActivity(){
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/activity/activity-summary/general/${this.generalData.account_code}`;
		if(window.location.protocol != 'file:'){
			window.open(path,'_blank')
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : path
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}

	setHierarchy(parentId,onload){
		let hierarchy = this.generalForm.value.hierarchy
		let account_type= this.generalForm.value.account_type
		if(!onload || !hierarchy){
			let parentAccount = this.groupList && this.groupList.filter(data=> {
				return data.id == parentId
			})
			if(parentAccount && parentAccount.length > 0){
				hierarchy = Number(parentAccount[0].hierarchy)+1
				account_type = parentAccount[0].account_type
			}
		}
		this.generalForm.controls.hierarchy.setValue(hierarchy)
		this.generalForm.controls.account_type.setValue(account_type)

	}

	changeCurrentAmount(event) {
		let currency = this.generalForm.controls.currency.value;
		let currency_rate = this.generalForm.controls.currency_rate.value;
		if(currency && currency_rate) {
			let local_balance = this.generalForm.controls.local_balance.value
			this.generalForm.controls.balance.setValue((Number(local_balance) / currency_rate).toFixed(2));
		} else {
			this.generalForm.controls.balance.setValue('')
		}
	}

	currencyChange(value){
		this.generalForm.controls.currency_rate.setValue('');
	
	}

	getAllBranches() {
        this.commonService.getOkount(`branch`).subscribe(res=> {
          if(res && res['data']) {
            this.branches = res['data'];
			let formObj = this.branches.reduce((acc,curr)=>{
				if(curr.branch_type=='BRANCH'){
					acc[curr.branch_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.generalForm.controls.branch.setValue(formObj)
          }
        },err=> {
    
        })
      }

	handleValueChange(e,branchName){
		console.log("branchName",this.generalForm.controls.branch)
		this.generalForm.controls.branch.value[branchName]=e.currentTarget.checked
	  }

	  async checkBalance(){
        let opening_amount = await  this.getOpeningBalanceData()
        if(this.generalForm.controls.balance_type.value=='debit') opening_amount['debit']= Number(opening_amount['debit']) + Number(this.generalForm.controls.balance.value)
        if(this.generalForm.controls.balance_type.value=='credit') opening_amount['credit']= Number(opening_amount['credit']) + Number(this.generalForm.controls.balance.value)
            console.log("opening_amount",opening_amount)
		if(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA')) {
			let userData = JSON.parse(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA'))
			if(userData && userData.tenant_id && (userData.tenant_id == environment.aadeshSystaccId || userData.tenant_id == environment.aadeshAedSystaccId)) {
				this.isAadesh = true;
			}
		}
        if(opening_amount && (opening_amount['debit']!=opening_amount['credit']) && this.isAadesh==false) {
            this.remainingAmount = Math.abs(Number((opening_amount['debit'] - opening_amount['credit']).toFixed(2)))
            this.amountType = opening_amount['debit']>opening_amount['credit'] ? 'credit' : 'debit'
			let res = await this.adjustAccOpeningBalance()
            if(res['balance']!=this.remainingAmount || this.amountType!=res['balance_type']){
                this.openOBConfirmModal()
			}else{
				this.updateOpeningBalancecombine()
			}
        }else{
            this.updateOpeningBalancecombine()
        }
    }
	adjustAccOpeningBalance(){
        return new Promise(async (resolve, reject) => {
        this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/globalsearch/opening_balance`, {client: 'OB0000165'}).subscribe(res => {
            resolve(res)
        },err=>{
            console.log("err",err)
            resolve(null)
        })
    })
    }
	
	getOpeningBalanceData(){
        return new Promise(async (resolve, reject) => {
            this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/openingBalanceTotal`, {"account_code":this.generalData.account_code}).subscribe(res => {
                resolve(res)
            },err=> {
                resolve(null)
            })
        })
    }
	openOBConfirmModal(){
		this.confirmOBModal.nativeElement.click()
	}
	 updateOpeningBalancecombine(){
        this.closeOBConfirmModal()
        this.updateGeneral()
    }
	closeOBConfirmModal(){
		this.closeOBModal.nativeElement.click()
	}
	updateOpeningBalanceAdjustAcc() {
        let req_body = {
            balance: this.remainingAmount,
            balance_type: this.amountType,
            account_code: 'OB0000165'
        }
        this.commonService.putRequest(`${environment.okountUrl}/client/updateOpeningBalanceAdjust`, req_body).subscribe(res => {
           
            console.log(res)
        }, err => {
        })

    }
	getAllCompanys() {
        this.commonService.getOkount(`company`).subscribe(res=> {
          if(res && res['data']) {
            this.companies = res['data'];
			let formObj = this.companies.reduce((acc,curr)=>{
				if(curr.associate_company_id!==null){
					acc[curr.tenant_company_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.generalForm.controls.company.setValue(formObj)
          }
        },err=> {
    
        })
      }
	  handleCompanyChange(e,companyName){
		console.log("companyName",this.generalForm.controls.company)
		this.generalForm.controls.company.value[companyName]=e.currentTarget.checked
	  }
}
	
